import { render } from "./App.vue?vue&type=template&id=c23d136c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c23d136c&lang=css"

import exportComponent from "D:\\archive\\my8\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__